import React from "react";
import styled from "styled-components";

import noChats from "../../Assets/images/noChats.svg";

function NoChats() {
    return (
        <>
            <ImageContainer>
                <img src={noChats} alt="No Chat Selected" />
            </ImageContainer>
        </>
    );
}

const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: 20px;
    img {
        width: 60%;
        margin-top: 10%;
    }
`;

export default NoChats;
